module.exports = __webpack_public_path__ + "img/box2.2d3d4f8b.png";